import {
  MessageReduxType,
  MessageStatus,
  MessageType,
} from "../constant/Types";

export const msg = {
  type: "",
  data: {
    file: {},
    link: "",
    text: "",
    serverType: "",
    highlighted: [],
  },
  metaData: {},
  time: "",
  status: "",
  temp: "",
  id: 0,
  reply: 0,
  cancelToken: "",
  clientMessageId: "",
};

// eslint-disable-next-line
export let fakeMsg = {
  type: MessageType.client.media,
  data: {
    file: {},
    link: "/files/test.wav",
    text: "",
  },
  time: new Date().getTime(),
  status: MessageStatus.sending,
  temp: "",
  id: 2,
  reply: 0,
  cancelToken: "",
  clientMessageId: "",
};

export const messageModel = [];
const data = localStorage.getItem("red-messages");
const initialize = data
  ? Object.assign(messageModel, JSON.parse(data))
  : messageModel;

let saveInStorage = false;

function storeInStorage(state) {
  if (saveInStorage) {
    localStorage.setItem("red-messages", JSON.stringify(state));
  }
}

function compareId(list, id, clientMessageId) {
  let result = false;

  if (list.length === 0) {
    return result;
  }

  list.forEach((item) => {
    if (
      item.id === id
      // ||
      // (item.clientMessageId &&
      //   clientMessageId &&
      // item.clientMessageId === id)
    ) {
      result = item;
    }
  });

  return result;
}

function parseAndSortMessages(states, newMessages) {
  let result = [...states];

  // check new Data in result
  if (result.length > 0) {
    result.map((item) => {
      let updatedItem = { ...item };

      let c = compareId(newMessages, item.id, item.clientMessageId);
      if (c) {
        return c;
      }
      return updatedItem;
    });
  }

  // debugger;

  // add newMessages
  newMessages.forEach((item) => {
    let exists = false;

    let c = compareId(result, item.id, item.clientMessageId);
    if (c) {
      exists = true;
    }

    if (!exists) {
      result.push(item);
    }
  });

  result = result.sort((a, b) => a.time - b.time);

  return result;
}

function deleteAndSortMessages(states, messageId) {
  let result = [...states];

  result = result.filter((message) => message.id !== messageId);

  return result;
}

let res;
export default function messagesRed(
  state = initialize,
  { data, type, ...action }
) {
  switch (type) {
    case MessageReduxType.add:
      res = parseAndSortMessages(state, [data]);
      storeInStorage(res);
      return res;
    case MessageReduxType.deleted:
      res = deleteAndSortMessages(state, data);
      storeInStorage(res);
      return res;
    case MessageReduxType.addBulk:
      res = parseAndSortMessages(
        action.firstFetch && action.firstFetch === true ? [] : state,
        data
      );
      storeInStorage(res);
      return res;
    case MessageReduxType.cancel:
      res = [...state];
      res.forEach((i, index) => {
        if (Number(i.id) === data.id) {
          if (i.temp.length > 0) {
            res.splice(index, 1);
          } else {
            i.status = MessageStatus.failed;
          }
        }
      });
      storeInStorage(res);
      return res;
    case MessageReduxType.updateStatus:
      res = [...state];
      res.forEach((i) => {
        if (i.clientMessageId === data.clientMessageId) {
          i.status = data.status;
          i.id = data.id;
          i.fileId = data.fileId;
          if (i.cancelToken) {
            i.cancelToken = data.cancelToken;
          }
        }
      });

      storeInStorage(res);
      return res;

    case MessageReduxType.updateVoice:
      res = [...state];
      res.forEach((i) => {
        if (i.id === data.id) {
          i.status = MessageStatus.ready;
          i.data = data.base64voice;
        }
      });
      // storeInStorage(res);
      return res;
    default:
      return state;
  }
}
